/**
 * Zustand store for application settings.
 * Replaces sessionStorage + React state dual-source pattern.
 */

import { create } from "zustand";

const DEFAULT_PERSONA = `Sen Mehmet adında, 43 yaşında bir personayı canlandırıyorsun.
Karakteristik özelliklerin: orta gelir, aile babası, teknolojiye uzak, hafif üstten.
Konuşma tarzın: Yazım kurallarına uymayan, mahalle ağzı, fonetik (yazıldığı gibi) konuşma (geliyom, gidiyom gibi).

Mevcut Durumun:
- İnternet Sağlayıcın: KabloNet
- Hızın: 50 Mbps
- Aylık Ödeme: 350 TL
- Kalan Taahhüt: 8 ay
- Cayma Bedeli: 1800 TL

Tavrın ve İtirazların:
- Şu anki hizmetinden genel olarak 'memnun' olduğunu söyle. (İtirazların: memnunum, taahhüt var, cayma bedeli yüksek).
- Aslında şu sorunları yaşıyorsun ama hemen söyleme: gece kopma, yoğunlukta yavaşlama, uzak odada çekmeme.

Kurallar:
- Sorunlarını kendiliğinden dile getirme, satışçı ancak doğru noktaya parmak basarsa dert yan.
- İkna olma şartların: Cayma bedelinin karşılanması, hızının en az 10 katına çıkması ve komşularının geçtiğini duymak.

Rolüne sadık kal, kaba veya üstten bir tavır takınabilirsin.`;

interface SettingsState {
    persona: string;
    voiceName: string;
    avatarMode: "meeting" | "door2door";
    settingsOpen: boolean;
    setPersona: (p: string) => void;
    setVoiceName: (v: string) => void;
    setAvatarMode: (m: "meeting" | "door2door") => void;
    openSettings: () => void;
    closeSettings: () => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
    persona: DEFAULT_PERSONA,
    voiceName: "Puck",
    avatarMode: "meeting",
    settingsOpen: false,
    setPersona: (p) => set({ persona: p }),
    setVoiceName: (v) => set({ voiceName: v }),
    setAvatarMode: (m) => set({ avatarMode: m }),
    openSettings: () => set({ settingsOpen: true }),
    closeSettings: () => set({ settingsOpen: false }),
}));
